<template>
  <div :class="{ ltr: $i18n.locale != 'fa' }">
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('description')"
      placement="bottom"
    >
      <i
        v-if="description != null && description != '' && showDesc == true"
        class="el-icon-chat-dot-square text-xl cursor-pointer text-blue-700"
        @click="$emit('open', description)"
      ></i>
    </el-tooltip>
    <slot></slot>

    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('VIEW')"
      placement="bottom"
    >
      <i
        v-if="view == true"
        class="el-icon-view text-xl cursor-pointer text-purple-700"
        @click="$emit('view', router.id)"
      ></i>
    </el-tooltip>

    <template v-if="Editable">
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('EDIT')"
        placement="bottom"
      >
        <router-link
          :to="{ name: router.name, params: { id: router.id } }"
          v-if="router.id != ''"
        >
          <i
            class="el-icon-edit-outline text-xl cursor-pointer text-yellow-500"
          ></i>
        </router-link>
        <i
          v-else
          class="el-icon-edit-outline text-xl cursor-pointer text-yellow-500"
          @click="$emit('edit', true)"
        ></i>
      </el-tooltip>
    </template>

    <el-tooltip
      class="item"
      effect="dark"
      v-if="isDeleteable"
      :content="$t('DELETE')"
      placement="bottom"
    >
      <el-popconfirm
        :confirm-button-text="$t('YES')"
        :cancel-button-text="$t('NO')"
        icon="el-icon-info"
        icon-color="red"
        :title="$t('SURE_DELETE', { type: title })"
        @confirm="$emit('remove', router.id)"
      >
        <el-button slot="reference" type="text" style="padding: 0">
          <i class="el-icon-delete text-xl cursor-pointer text-red-500"></i>
        </el-button>
      </el-popconfirm>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tes: this.$i18n.t('INDEX'),
    }
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    router: {
      type: Object,
      default: () => {
        return {
          name: '',
          id: '',
        }
      },
    },
    showDesc: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: function () {
        return this.$i18n.t('INDEX')
      },
    },
    view: {
      type: Boolean,
      default: false,
    },
    editLink: {
      type: Boolean,
      default: true,
    },
    Editable: {
      type: Boolean,
      default: true,
    },
    isDeleteable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
